<template>
    <div class="read-more-lineclamp">
        <div class="read-more-lineclamp__content" :class="{ collapsed }" :style="style" ref="content">
            <slot />
        </div>
        <template v-if="hasMore && !disabled">
            <div>
                <a class="read-more-link" href="#more" @click.prevent="collapsed = !collapsed">
                    lire
                    <template v-if="collapsed">+</template>
                    <template v-else>-</template>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            lineClamp: {
                type: Number,
                default: 3,
            },
            disabled: Boolean,
        },
        data() {
            return {
                collapsed: !this.disabled,
                hasMore: false,
                legacy: false,
            }
        },
        computed: {
            style() {
                return {
                    '--line-clamp': this.lineClamp
                }
            }
        },
        async mounted() {
            if(this.disabled) {
                return;
            }
            const content = this.$refs.content;
            const collapsedHeight = content.offsetHeight;
            content.classList.remove('collapsed');
            const maxHeight = content.style.maxHeight;
            content.style.maxHeight = '';

            this.hasMore = content.offsetHeight > collapsedHeight;
            content.classList.add('collapsed');
            content.style.maxHeight = maxHeight;
        }
    }
</script>
